<template>

    <v-modal
        :open="open"
        inner-class="c-modal_p1_report">
        <button
            class="c-modal_p1_report__close"
            type="button"
            @click="close">
        </button>
        <h3 class="c-modal_p1_report__title">Szczegóły raportowania Zdarzenia Medycznego do Systemu P1</h3>
        <div class="c-modal_p1_report__list">

            <div class="p1-report" v-for="(p1Report, p1ReportIndex) in p1Reports" :key="'p1Report-' + p1ReportIndex">

                <div class="p1-report__header">
                    <div class="p1-report__header__icon" :class="p1Report.status"></div>
                    <div class="p1-report__header__text">Raport nr {{ p1Reports.length - p1ReportIndex }}</div>
                </div>

                <div class="p1-report__content">

                    <div class="p1-report__content__summary" :class="p1Report.status">{{ p1Report.user_log }}</div>

                    <div class="p1-report__content__created_at">Data rozpoczęcia przesyłania: {{ p1Report.created_at }}</div>
                    <div class="p1-report__content__updated_at">Data {{ (p1Report.status === 'finished' || p1Report.status === 'cancelled') ? 'zakończenia' : 'ostatniej aktualizacji'  }} przesyłania: {{ p1Report.updated_at }}</div>

                    <div class="p1-report__content__detailed-log" v-if="p1Report.detailed_user_log && p1Report.detailed_user_log.length">

                        <div class="p1-report__content__detailed-log__title">Szczegółowe informacje:</div>

                        <div class="p1-report__content__detailed-log__entry" v-for="(logEntry, logEntryIndex) in p1Report.detailed_user_log" :key="'logEntry-' + logEntryIndex">

                            <div class="p1-report__content__detailed-log__entry__header">
                                <div class="p1-report__content__detailed-log__entry__header__icon_and_resource">
                                    <div class="p1-report__content__detailed-log__entry__header__icon_and_resource__icon" :class="logEntry.status"></div>
                                    <div class="p1-report__content__detailed-log__entry__header__icon_and_resource__resource">{{ getResourceText(logEntry.resource) }}</div>
                                </div>
                                <div class="p1-report__content__detailed-log__entry__header__date">{{ logEntry.date }}</div>
                            </div>

                            <div class="p1-report__content__detailed-log__entry__content">

                                <div class="p1-report__content__detailed-log__entry__content__result" v-html="getResultText(logEntry)"></div>

                                <div class="p1-report__content__detailed-log__entry__content__resource-id" v-if="logEntry.resource_id">
                                    <div class="p1-report__content__detailed-log__entry__content__resource-id__title">ID: </div>
                                    <div class="p1-report__content__detailed-log__entry__content__resource-id__id" v-for="id in logEntry.resource_id.split(',')" :key="id">{{ id }}</div>
                                </div>

                                <ul class="p1-report__content__detailed-log__entry__content__errors" v-if="logEntry.errors.length">
                                    <li v-for="(error, errorIndex) in logEntry.errors" :key="'error-' + errorIndex">{{ error }}</li>
                                </ul>

                            </div>



                        </div>
                    </div>

                </div>
            </div>

        </div>

        <v-loader :loading="isFetching"></v-loader>
    </v-modal>

</template>


<script>

import {mapGetters} from 'vuex'
import VLoader from 'Components/VLoader'
import VModal from 'Components/VModal'

export default {

    name: 'VisitP1ReportModals',

    data() {
        return {
            isFetching: null,
            open: false,
            visit: null,
            p1Reports: [],
            refreshInterval: null,
        }
    },

    methods: {
        getResourceText(resource) {
            switch (resource) {
                case 'Patient':
                    return 'Zasób danych pacjenta';
                case 'Encounter':
                    return 'Zasób podstawowych danych wizyty';
                case 'Procedure':
                    return 'Zasoby procedur medycznych';
                case 'Condition':
                    return 'Zasoby rozpoznania medycznego';
                case 'Provenance':
                    return 'Zasób potwierdzający';
                default:
                    return 'Nieznany zasób';
            }
        },
        getResultText(logEntry) {
            if (logEntry.status === 'skip') {
                return 'Brak zasobów do procesowania.';
            }
            if (logEntry.status === 'started') {
                return 'Przetwarzanie w toku.';
            }
            if (!logEntry.result) {
                return 'Brak informacji o wyniku.';
            }
            const resultParts = logEntry.result.split(',');
            if (resultParts.length === 1) {
                return this.getSingleResultText(logEntry.result);
            } else {
                return this.getMultipleResultText(resultParts);
            }
        },
        getSingleResultText(result) {
            switch (result) {
                case 'found':
                    return 'Zasób został odnaleziony poprawnie.';
                case 'fetched':
                    return 'Zasób został pobrany poprawnie.';
                case 'created':
                    return 'Zasób został utworzony poprawnie.';
                case 'updated':
                    return 'Zasób został zaktualizowany poprawnie.';
                case 'deleted':
                    return 'Zasób został usunięty poprawnie.';
                case 'fhir_error':
                    return 'Serwer FHIR CSIOZ (P1) zwrócił błąd.';
                case 'app_error':
                    return 'Wystąpił błąd wewnętrzny. Skontaktuj się administracją aplikacji.';
                default:
                    return 'Nieznany wynik.';
            }
        },
        getMultipleResultText(results) {
            let resultTexts = [];
            results.forEach((result, index) => {
                resultTexts.push(parseInt(index + 1) + '/' + results.length + ': ' + this.getSingleResultText(result));
            });
            return resultTexts.join('<br>');
        },
        fetchP1Reports(usingIsFetching = true) {
            if (!this.visit) {
                return;
            }

            if (usingIsFetching) {
                this.isFetching = true
            }
            this.$store.dispatch('VISIT_P1_REPORTS_FETCH', this.visit.id).then(({data}) => {
                this.p1Reports = data.data;
                this.$emit('fetched', data.data);
            }).catch((error) => {
                this.open = false
                this.$alert.error('Pobieranie szczegółów raportowania', error.response.data.message)
            }).finally(() => {
                if (usingIsFetching) {
                    this.isFetching = false
                }
                this.checkAndRefreshP1Reports();
            })
        },
        checkAndRefreshP1Reports() {
            if (this.p1Reports.some(p1Report => p1Report.status === 'started' || p1Report.status === 'pending')) {
                if (!this.refreshInterval) {
                    this.refreshInterval = setInterval(() => {
                        this.fetchP1Reports(false);
                    }, 3000);
                }
            } else if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
                this.refreshInterval = null;
            }
        },
        close() {
            this.open = false
            this.$emit('close')
        }
    },

    // watch: {
    //     'p1Reports.data': function() {
    //         this.checkAndRefreshP1Reports();
    //     },
    // },

    mounted() {
        this.$on('open', (visit) => {
            this.visit = visit
            this.open = true
            this.fetchP1Reports()
        })
    },

    beforeDestroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
        this.$off('open')
    },

    components: {
        VModal,
        VLoader
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_p1_report {
    position: relative;
    max-width: 800px !important;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    &__title {
        text-align: center;
    }
    &__close {
        cursor: pointer;
        background-color: transparent;
        border: none;
        outline: 0 !important;
        position: absolute;
        top: 5px;
        right: 5px;
        width: 30px;
        height: 30px;
        background-image: url('#{$icons}/delete1.svg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 1rem 1rem;
    }
    &__empty {
        font-size: 1.2rem;
        color: $c-secondary;
        text-align: center;
        width: 100%;
        margin: 100px 0;
    }
    &__list {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;

        &__table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid $c-secondary;

            td {
                padding: 0.5rem;
                border: 1px solid $c-secondary;
            }
        }
    }
}

.p1-report {
    border: 1px solid #EBEDF8;
    margin-bottom: 30px;

    &__header {
        display: flex;
        align-items: center;
        background: #f8f8f8;
        border-bottom: 1px solid #EBEDF8;
        padding: 10px 15px;

        &__icon {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            background-position: center;
            background-repeat: no-repeat;
            margin-right: 10px;

            &.pending {
                z-index: 1;
                background-color: $c-secondary;
                background-image: url('#{$icons}/tick.svg');
                background-size: 13px 10px;
            }

            &.started {
                background-color: $c-secondary;
                -webkit-mask-image: url('#{$icons}/loader-cropped.svg');
                mask-image: url('#{$icons}/loader-cropped.svg');
                transform: rotate(0deg);
                animation: btn-loading 1s linear infinite;

                @keyframes btn-loading {
                    100% {
                        transform: rotate(360deg);
                    }
                }
            }

            &.finished {
                z-index: 1;
                background-color: $c-success;
                background-image: url('#{$icons}/tick.svg');
                background-size: 13px 10px;
            }

            &.cancelled {
                z-index: 1;
                background-color: $c-warning;
                background-image: url('#{$icons}/tick.svg');
                background-size: 13px 10px;
            }

            &.error {
                z-index: 2;
                background-color: $c-red;
                background-image: url('#{$icons}/error1.svg');
                background-size: 13px 13px;
            }
        }
        &__text {
            font-size: 1rem;
            font-weight: bold;
        }
    }

    &__content {
        padding: 15px;

        &__summary {
            font-weight: bold;
            margin-bottom: 15px;

            &.pending,
            &.started {
                color: $c-secondary;
            }

            &.finished {
                color: $c-success;
            }

            &.cancelled {
                color: $c-warning;
            }

            &.error {
                color: $c-red;
            }
        }

        &__created_at {
            margin-bottom: 10px;
        }

        &__updated_at {

        }

        &__detailed-log {
            margin-top: 15px;

            &__title {
                //font-weight: bold;
            }

            &__entry {
                background: #f8f8f8;
                margin-top: 10px;
                position: relative;

                &__header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid #EBEDF8;
                    padding: 10px;

                    &__icon_and_resource {
                        display: flex;
                        align-items: center;

                        &__icon {
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                            background-position: center;
                            background-repeat: no-repeat;
                            margin-right: 10px;

                            &.skip {
                                z-index: 1;
                                background-color: $c-secondary;
                                background-image: url('#{$icons}/tick.svg');
                                background-size: 10px 8px;
                            }

                            &.started {
                                background-color: $c-secondary;
                                -webkit-mask-image: url('#{$icons}/loader-cropped.svg');
                                mask-image: url('#{$icons}/loader-cropped.svg');
                                transform: rotate(0deg);
                                animation: btn-loading 1s linear infinite;

                                @keyframes btn-loading {
                                    100% {
                                        transform: rotate(360deg);
                                    }
                                }
                            }

                            &.success {
                                z-index: 1;
                                background-color: $c-success;
                                background-image: url('#{$icons}/tick.svg');
                                background-size: 8px 6px;
                            }

                            &.fail {
                                z-index: 2;
                                background-color: $c-red;
                                background-image: url('#{$icons}/error1.svg');
                                background-size: 8px 6px;
                            }
                        }

                        &__resource {
                            font-weight: bold;
                            margin-right: 10px;
                        }
                    }

                    &__date {
                        font-size: 0.8rem;
                    }
                }

                &__content {
                    padding: 10px;

                    &__result {
                        //margin-right: 10px;
                    }

                    &__resource-id {
                        margin-top: 10px;

                        &__title {
                            display: inline-block;
                            margin-right: 5px;
                            position: relative;
                            top: 1px;
                        }

                        &__id {
                            background: #c1c1c1;
                            color: white;
                            padding: 2px 4px;
                            border-radius: 5px;
                            display: inline-block;
                            font-size: 0.8rem;
                            margin-right: 5px;
                        }
                    }

                    &__errors {
                        margin-top: 10px;
                        list-style-type: disc;
                        padding-left: 15px;

                        li {
                            color: $c-red;
                            margin-top: 5px;
                        }
                    }
                }


            }
        }
    }
}

</style>
